import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_notification_detail_content = _resolveComponent("notification-detail-content")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, null, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_v_card_title, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_spacer),
            _createVNode(_component_v_btn, {
              icon: "",
              dark: "",
              onClick: _ctx.cancel,
              fab: "",
              class: "error",
              "x-small": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => _cache[0] || (_cache[0] = [
                    _createTextVNode("mdi-close")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [
            _createVNode(_component_notification_detail_content, {
              item: _ctx.notificationItem,
              isClient: _ctx.isClient,
              isAdmin: _ctx.isAdmin,
              isTeamMember: _ctx.isTeamMember,
              userId: _ctx.userId,
              onInitNotifications: _ctx.initNotifications,
              onSuccessRaise: _ctx.successRaise,
              onErrorRaise: _ctx.errorRaise
            }, null, 8, ["item", "isClient", "isAdmin", "isTeamMember", "userId", "onInitNotifications", "onSuccessRaise", "onErrorRaise"]),
            _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1))
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}